import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function MobileNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navItems = [
    { id: 'home', label: 'Home', path: '/', icon: 'home' },
    { id: 'search', label: 'Search', path: '/gallery', icon: 'search' },
    { id: 'analytics', label: 'Analytics', path: '/activity-dashboard', icon: 'analytics' },
    { id: 'history', label: 'History', path: '/echo-chamber', icon: 'history' },
    { id: 'profile', label: 'Profile', path: '/profile', icon: 'profile' }
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path.split('/').slice(0, -1).join('/'));

  const getIcon = (iconType) => {
    switch (iconType) {
      case 'home':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        );
      case 'search':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
        );
      case 'analytics':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="2" x2="12" y2="22" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        );
      case 'history':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        );
      case 'profile':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        );
      default:
        return null;
    }
  };

  if (!isMobile) return null;

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 72,
      background: 'rgba(30, 30, 30, 0.95)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(201,166,43,0.2)',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 1000,
      paddingBottom: 'max(0px, env(safe-area-inset-bottom))'
    }}>
      {navItems.map((item) => {
        const isCurrentActive = isActive(item.path);
        return (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 6,
              padding: '8px 16px',
              color: isCurrentActive ? '#c9a62b' : '#999',
              transition: 'all 0.3s ease',
              fontSize: 12,
              fontWeight: 500,
              flex: 1
            }}
            onMouseEnter={(e) => {
              if (!isCurrentActive) {
                e.currentTarget.style.color = '#e0e0e0';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = isCurrentActive ? '#c9a62b' : '#999';
            }}
          >
            <div style={{
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              background: isCurrentActive ? 'rgba(201,166,43,0.2)' : 'transparent',
              transition: 'all 0.3s ease'
            }}>
              {getIcon(item.icon)}
            </div>
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
